import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
import { onMounted, reactive } from 'vue';
import AudiencesImportation from '@/components/audiences/importation/AudiencesImportation.vue';
import AudienceManagementHeaderTable from '@/features/AudienceManagement/components/AudienceManagementHeaderTable.vue';
import AudienceManagementTable from '@/features/AudienceManagement/components/AudienceManagementTable.vue';
import AudienceManagementEmptyTable from '@/features/AudienceManagement/components/AudienceManagementEmptyTable.vue';
import { useMixpanelConfig } from '@/utilities/mixpanel';
import { MixpanelEvents } from '@/features/AudienceManager/utils';
export default /*#__PURE__*/ _defineComponent({
    __name: 'AudienceManagement',
    setup(__props) {
        const state = reactive({
            search: '',
            selectedOption: {
                id: '',
                name: '',
            },
            loading: false,
            isEmptyTable: false,
        });
        const searchAudience = value => {
            state.search = value;
        };
        const selectedPreset = preset => {
            state.selectedOption = preset;
        };
        onMounted(() => {
            useMixpanelConfig(MixpanelEvents.BASE_AUDIENCES_VIEWED);
        });
        return (_ctx, _cache) => {
            const _component_base_card_v2 = _resolveComponent("base-card-v2");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(AudiencesImportation),
                _createVNode(_component_base_card_v2, null, {
                    default: _withCtx(() => [
                        (!state.loading)
                            ? (_openBlock(), _createBlock(AudienceManagementHeaderTable, {
                                key: 0,
                                "is-empty-table": state.isEmptyTable,
                                onSearchAudience: searchAudience,
                                onSelectedPreset: selectedPreset
                            }, null, 8, ["is-empty-table"]))
                            : _createCommentVNode("", true),
                        (!state.isEmptyTable)
                            ? (_openBlock(), _createBlock(AudienceManagementTable, {
                                key: 1,
                                onInitialLoading: _cache[0] || (_cache[0] = value => (state.loading = value)),
                                onVerifyEmptyTable: _cache[1] || (_cache[1] = value => (state.isEmptyTable = value)),
                                search: state.search,
                                "selected-option": state.selectedOption
                            }, null, 8, ["search", "selected-option"]))
                            : _createCommentVNode("", true),
                        (state.isEmptyTable)
                            ? (_openBlock(), _createBlock(AudienceManagementEmptyTable, { key: 2 }))
                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                })
            ], 64));
        };
    }
});
